import styles from "./HeroV2.module.scss";
import { useRef, useState, useEffect } from "react";
import useToggleShowNavbar from "hooks/useToggleShowNavbar";
import HeaderDesktop from "@Components/Header/HeaderDesktop";
import Header from "@Components/Header";
import HeroContent from "./components/HeroContent/HeroContent";
import HeroImageContainer from "./components/HeroImageHolder/HeroImageHolder";
import HeroStatsBar from "./components/HeroStatsBar/HeroStatsBar";
import HeroV2Mobile from "../HeroV2Mobile/HeroV2Mobile";
import wrapperHOC from "@Utils/wrapperHOC";
import { SCHOLARSHIP_PAGE_STATIC_URL } from "constants/index";

const HeroV2 = ({ isScholarshipPage = false }: { isScholarshipPage?: boolean }) => {
  const heroSectionRef: any = useRef();
  const searchBarRef: any = useRef();
  const [isSearchScrolledUp, setIsSearchScrolledUp] = useState(false);
  const [showSearchButtonOnScrollBar, setShowSearchButtonOnScrollBar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useToggleShowNavbar(heroSectionRef, setIsSearchScrolledUp);
  useToggleShowNavbar(searchBarRef, setShowSearchButtonOnScrollBar);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 650);
      setIsLargeScreen(window.innerWidth > 1200);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Use mobile hero for screens 650px and below
  if (isMobile) {
    return <HeroV2Mobile isScholarshipPage={isScholarshipPage} />;
  }

  return (
    <>
      <div className={`${styles.stickyHeader}${isSearchScrolledUp ? ` ${styles.visible}` : ""}`}>
        {showSearchButtonOnScrollBar ? (
          <HeaderDesktop
            hideAppBanner
            isScholarshipPage={isScholarshipPage}
            showSearchButtonOnScrollBar
          />
        ) : (
          <HeaderDesktop hideAppBanner hideSearchBar isScholarshipPage={isScholarshipPage} />
        )}
      </div>
      {isLargeScreen ? (
        <HeaderDesktop
          hideSearchBar
          transparentBg
          isFixed
          hideAppBanner
          showCookiePolicy
          isScholarshipPage={isScholarshipPage}
        />
      ) : (
        <Header hideSearchBar isScholarshipPage={isScholarshipPage} />
      )}
      <div
        className={styles.refParentContainer}
        style={{ backgroundImage: `url(${SCHOLARSHIP_PAGE_STATIC_URL}/scholar_hero_bg.png)` }}
      >
        <div className={styles.refOverlayContainer}>
          <div className={styles.refContentContainer} ref={heroSectionRef}>
            <HeroContent />
            <HeroImageContainer />
          </div>
          <HeroStatsBar />
          <div className={styles.refHookContainer} ref={searchBarRef} />
        </div>
      </div>
    </>
  );
};

export default wrapperHOC(HeroV2, {
  componentName: "HeroV2-ScholarshipDesktop",
  showForChina: true,
});
